import React from 'react';
import { DateInput } from '../date-input/date-input';

export default function CallTimeField() {
	return (
		<DateInput
			name='time'
			showTimeSelect
			showTimeSelectOnly
			receptionTime='06:00-22:00'
			dateFormat="HH:mm"
			mask='99:99'
			timeCaption="Время"
			autoComplete="off"
			placeholderText='Выберите время'
		/>
	)
}